import React, { useEffect, useState } from 'react';
import API from '../../../utils/axiosInstance';
import '../../../assets/css/Sidebar.css';

const DoctorSchedule = () => {
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState('');
  const [scheduleDate, setScheduleDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [slotInterval, setSlotInterval] = useState('');
  const [unavailableSlots, setUnavailableSlots] = useState([{ startTime: '', endTime: '' }]);
  const [generatedSlots, setGeneratedSlots] = useState([]);

  useEffect(() => {
    API.get('/v1/users')
      .then((response) => setDoctors(response.data.filter(u => u.roles?.some(r => r.name === 'DOCTOR'))))
      .catch((error) => console.error('Error fetching doctors:', error));
  }, []);

  const handleUnavailableChange = (index, field, value) => {
    const updated = [...unavailableSlots];
    updated[index][field] = value;
    setUnavailableSlots(updated);
  };

  const addUnavailableRow = () => {
    setUnavailableSlots([...unavailableSlots, { startTime: '', endTime: '' }]);
  };

  const deleteUnavailableRow = (index) => {
    setUnavailableSlots(unavailableSlots.filter((_, i) => i !== index));
  };

  const generateSchedule = async () => {
    if (!selectedDoctorId) return alert("Please select a doctor first.");

    const payload = {
      doctorId: parseInt(selectedDoctorId, 10),
      scheduleDate,
      startTime,
      endTime,
      slotInterval: parseInt(slotInterval, 10),
      unavailableSlots
    };

    try {
      const response = await API.post(`/v1/doctors/${selectedDoctorId}/schedule/create`, payload);
      alert("Schedule created successfully.");
      setGeneratedSlots(response.data.appointmentSlots || []);
    } catch (error) {
      console.error('Error generating schedule:', error);
      alert('Failed to generate schedule.');
    }
  };

  return (
    <div className="schedule-container">
      <div style={{ padding: '20px' }}>
        <h4>Doctor Schedule</h4>

        <div className="row">
          <div className="col-md-6">
            <label>Select Doctor: </label>
            <select onChange={(e) => setSelectedDoctorId(e.target.value)} value={selectedDoctorId}>
              <option value="">-- Select Doctor --</option>
              {doctors.map((doc) => (
                <option key={doc.id} value={doc.id}>{doc.fullName}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <label>Schedule Date:</label>
            <input type="date" value={scheduleDate} onChange={(e) => setScheduleDate(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label>Start Time:</label>
            <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label>End Time:</label>
            <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
          </div>
          <div className="col-md-3">
            <label>Slot Interval (in minutes):</label>
            <input type="number" value={slotInterval} onChange={(e) => setSlotInterval(e.target.value)} />
          </div>
        </div>

    

        <div className="row">
          <div className="col-md-12">
            <h4>Unavailable Timings</h4>
            {unavailableSlots.map((slot, index) => (
              <div className="row unavailable-slot-row" key={index}>
                <div className="col-md-4">
                  <input
                    type="time"
                    value={slot.startTime}
                    onChange={(e) => handleUnavailableChange(index, 'startTime', e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="time"
                    value={slot.endTime}
                    onChange={(e) => handleUnavailableChange(index, 'endTime', e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <button onClick={() => deleteUnavailableRow(index)}>Delete</button>
                </div>
              </div>
            ))}
            <button onClick={addUnavailableRow}>Add More Rows</button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <button onClick={generateSchedule} style={{ marginTop: '15px' }}>Generate Schedule</button>
          </div>
        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-md-12">
            <h4>Generated Slots</h4>
            <table border="1" cellPadding="5">
              <thead>
                <tr>
                  <th>Slot ID</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {generatedSlots.map((slot, idx) => (
                  <tr key={idx}>
                    <td>{slot.slotId}</td>
                    <td>{slot.startTime}</td>
                    <td>{slot.endTime}</td>
                    <td>{slot.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorSchedule;
